// extracted by mini-css-extract-plugin
export default {"checkbox":"_2UKKy","align-items-center":"_1WybL","alignItemsCenter":"_1WybL","label-unset-font":"_3pJcc","labelUnsetFont":"_3pJcc"};